export default "__VITE_ASSET__CmQIxUit__"